import {Injectable} from '@angular/core';

import {Subject} from 'rxjs';

import {
    CompanyDocumentModel,
    IndividualDocumentModel,
    IndividualsService,
    LinkedAccountModel,
    TradingClientModel,
    TradingPlatformInfoModel,
    FundProductInterface,
    PaymentReportModel,
    FundProductPriceModel,
    TradingPlanResponseModel, BrokerGetOutputModel, RouteGetOutputModel, RouteSetGetOutputModel,
    BrokerSearchOutputItemModel, RouteSearchOutputModel, RouteSetSearchOutputModel,
    CouponDetailInterface,
    CloseoutPlanDetailInterface
} from '@spa/api';

@Injectable({
    providedIn: 'root'
})
export class EventsService {
    public viewTitle: Subject<string>;
    public viewText: Subject<string>;

    public forceIndividualAmlRiskCalculation: Subject<boolean>;
    public forceIndividualTradingClientGet: Subject<TradingClientModel>;
    public forceIndividualTransactionsGet: Subject<boolean>;
    public forceIndividualBankAccountsGet: Subject<LinkedAccountModel>;
    public forceClientDocumentGet: Subject<IndividualDocumentModel | CompanyDocumentModel>;
    public forceClientUserGet: Subject<boolean>;
    public forceClientTradingPlatformsChanged: Subject<TradingPlatformInfoModel[]>;
    public forceClientAccountsAccessRightsGet: Subject<boolean>;
    public forceSupervisedRightsGet: Subject<boolean>;
    public forceAssignedAccountUsersGet: Subject<boolean>;
    public forceProductWithPricesGet: Subject<FundProductPriceModel[]>;
    public forceProductGet: Subject<FundProductInterface>;
    public forcePaymentGet: Subject<boolean>;
    public forcePaymentReportGet: Subject<{payment: PaymentReportModel, triggers: number[]}>;
    public forcePlanGet: Subject<{ plan: TradingPlanResponseModel}>;
    public forceCouponGet: Subject<CouponDetailInterface>;
    public forceCloseoutPlanGet: Subject<CloseoutPlanDetailInterface>;
    public forceExecutionBrokerGet: Subject<{ broker: BrokerGetOutputModel}>;
    public forceExecutionRouteGet: Subject<{ route: RouteGetOutputModel}>;
    public forceExecutionRouteSetGet: Subject<{ routeSet: RouteSetGetOutputModel}>;
    public hideInfoSection: Subject<boolean>;
    public forceCashBalance: Subject<string>;
    public planRoutesChanged: Subject<{
        sourceId: string;
        planId?: string | number;
        currentBroker?: BrokerSearchOutputItemModel;
        planRoutes?: RouteSearchOutputModel;
        planRouteSets?: RouteSetSearchOutputModel;
        availableRoutes?: RouteSearchOutputModel;
        availableRouteSets?: RouteSetSearchOutputModel;
    }>;

    public sidebarStateChanged: Subject<boolean>;
    public triggerPreview: Subject<{ mimeType: string, data: string }[]>;
    public orderUpdated: Subject<boolean>;

    constructor(
        public individualsService: IndividualsService
    ) {
        this.viewText = new Subject();
        this.viewTitle = new Subject();

        this.forceIndividualAmlRiskCalculation = new Subject();
        this.forceIndividualTradingClientGet = new Subject();
        this.forceIndividualTransactionsGet = new Subject();
        this.forceIndividualBankAccountsGet = new Subject();
        this.forceClientDocumentGet = new Subject();
        this.forceClientUserGet = new Subject();
        this.forceClientTradingPlatformsChanged = new Subject();
        this.forceClientAccountsAccessRightsGet = new Subject();
        this.forceSupervisedRightsGet = new Subject();
        this.forceAssignedAccountUsersGet = new Subject();
        this.triggerPreview = new Subject();
        this.sidebarStateChanged = new Subject();
        this.forceProductWithPricesGet = new Subject();
        this.forceProductGet = new Subject();
        this.forcePaymentGet = new Subject();
        this.forcePaymentReportGet = new Subject();
        this.orderUpdated = new Subject();
        this.forcePlanGet = new Subject();
        this.forceCouponGet = new Subject();
        this.forceCloseoutPlanGet = new Subject();
        this.hideInfoSection = new Subject();
        this.forceCashBalance = new Subject();
        this.forceExecutionBrokerGet = new Subject();
        this.forceExecutionRouteGet = new Subject();
        this.forceExecutionRouteSetGet = new Subject();
        this.planRoutesChanged = new Subject();

    }
}
